<template>
    <div class="Login">
        <v-content>

        <v-app-bar
          color="primary"
          dark
        >
    
          <v-toolbar-title>ToothCase</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn text small>Pricing</v-btn>
          <v-btn text small>About</v-btn>
          <v-btn text small>Contact</v-btn>
        </v-app-bar>
      <v-container
        fluid
        fill-height
      >
        <v-row justify="center" align="center">
          <v-col cols="12" sm="4">
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title class="text-uppercase">
                <span>Tooth</span>
                <span class="font-weight-light">Case</span>

                </v-toolbar-title>   
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Email"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                    filled
                    rounded
                    dense
                    required
                    v-model="email"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    filled
                    rounded
                    dense
                    required
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <a class="pl-4" @click="forgotPassword()">Forgot Password?</a>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    </div>
</template>

<script>
import firebase from 'firebase';
import swal from 'sweetalert2';

export default {
    name: 'loginPage',
    components: {

    },
    data(){
      return {
        loggedIn: false,
        email: "",
        password: "",
        error: null
      }
    },
    methods: {
      login: function(e){
        var that = this;
        firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(function (user) {
            that.$router.replace({name: 'LoadingScreen', params: {user: user.user, loginStatus: true}});
          })
          .catch(err => {
            this.error = err.message;
            swal.fire({title: "Error occured logging in!", text: `Please try again: ${this.error}`, icon: "error", showConfirmButton: false});
          });
          e.preventDefault();
      },
      async forgotPassword(){
        var auth = firebase.auth();

        const { value: emailAddress } = await swal.fire({
          title: 'Send Reset Password Email?',
          input: 'email',
          inputPlaceholder: 'Enter your email address'
        })

        if (emailAddress) {
          auth.sendPasswordResetEmail(emailAddress).then(function() {
            // Email sent.
            swal.fire({title: "Password reset email successfully sent!", text: `Please check your emails, sent to: ${emailAddress}`, icon: "success", showConfirmButton: false});
          }).catch(function(error) {
            // An error happened.
            swal.fire({title: "Error occured resetting pasword!", text: `${error}`, icon: "error", showConfirmButton: false});
          });
        }        
      }
    }
}

</script>